import {BrandColors} from "./types";
import {tokens} from "../tokens/tokens";
import {alpha} from "@mui/material";

export const defaultPalette: BrandColors = {
    primary: {
        main:         tokens.colors.navy700,
        dark:         tokens.colors.navy800,
        light:        tokens.colors.navy300,
        contrastText: tokens.colors.white,
    },

    secondary: {
        main:         tokens.colors.slate600,
        dark:         tokens.colors.gray900,
        light:        tokens.colors.slate400,
        contrastText: tokens.colors.white,
    },

    link: {
        main:         tokens.colors.blue600,
        dark:         tokens.colors.blue700,
        light:        tokens.colors.slate300,
        contrastText: tokens.colors.blue600,
    },

    text: {
        primary:     tokens.colors.navy600,
        secondary:   tokens.colors.slate600,
        disabled:    tokens.colors.slate300,
        hint:        tokens.colors.slate400,
        inverse:     tokens.colors.white,
        placeholder: tokens.colors.slate300,
    },

    background: {
        default:  tokens.colors.gray50,
        paper:    tokens.colors.white,
        subtle:   tokens.colors.gray300,
        overlay:  'rgba(0, 0, 0, 0.5)',
        dropzone: tokens.colors.slate100,
        element:  alpha(tokens.colors.slate200, 0.25),
        input:    tokens.colors.white,
    },

    action: {
        hover:              alpha(tokens.colors.navy700, 0.06),
        hoveredBackground:  tokens.colors.navy50,
        selected:           alpha(tokens.colors.navy700, 0.12),
        selectedBackground: alpha(tokens.colors.slate200, 0.36),
        focus:              alpha(tokens.colors.navy700, 0.12),
        disabled:           tokens.colors.slate300,
        disabledBackground: tokens.colors.gray500,
        delete:             tokens.colors.red500,
        dragDrop:           tokens.colors.blue800,
        hoveredDropzone:    alpha(tokens.colors.slate200, 0.25),
    },

    layout: {
        main:    tokens.colors.gray50,
        sidebar: tokens.colors.gray100,
    },

    dividers: {
        light:   tokens.colors.gray200,
        subtle:  tokens.colors.gray300,
        default: tokens.colors.slate200,
        strong:  tokens.colors.gray500,
        focus:   tokens.colors.slate600,
    },

    message: {
        userText:        tokens.colors.slate600,
        userBg:          alpha(tokens.colors.slate200, 0.2),
        userTextBg:      alpha(tokens.colors.slate200, 0.15),
        assistantText:   tokens.colors.navy600,
        assistantBg:     tokens.colors.gray200,
        assistantTextBg: tokens.colors.gray200,
        thinking:        alpha(tokens.colors.navy600, 0.5),
    },
};